var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_main"},[_c('el-row',{attrs:{"gutter":20}},_vm._l((_vm.dataInfo),function(item){return _c('el-col',{key:item.id,attrs:{"span":8}},[_c('div',{staticClass:"bg-color-light",on:{"click":function($event){return _vm.divClick(item.id)}}},[_vm._v(_vm._s(item.workName))])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }